<template>
  <div class="main-wrap">
    <main-header />
    
    <!-- Enhanced Service Hero -->
    <service-hero
      :title="service.title"
      :description="service.body"
      :image="service.img"
      :image-alt="$t('seo.desktop.title')"
      :badge="$t('header.services')"
      badge-icon="mdi-laptop"
      :primary-button="{
        text: $t('apps.pricingOrder'),
        to: '/services/desktop#contact',
        icon: 'mdi-rocket-launch'
      }"
      :tech-stack="[
        { name: 'Electron', icon: 'mdi-electron-framework', color: 'teal' },
        { name: 'Qt', icon: 'mdi-application-brackets', color: 'green' },
        { name: 'Windows', icon: 'mdi-microsoft-windows', color: 'blue' },
        { name: 'macOS', icon: 'mdi-apple', color: 'grey darken-2' },
        { name: 'Linux', icon: 'mdi-linux', color: 'orange' }
      ]"
      :stats="[
        { value: '200+', label: $t('landing.projects') },
        { value: '98%', label: $t('landing.quality') },
        { value: '24/7', label: $t('landing.support') }
      ]"
      theme-variant="default"
      :reverse-layout="true"
    />

    <counter dark :data="data" />
    <v-container id="steps">
      <main-feature id="feature" class="ma-0 mt-16" :features="features" :title="$t('desktop.featureTitle')" />
      <process-timeline :title="$t('desktop.processTitle')" :process-steps="years" />
    </v-container>

    <!-- Portfolio/Case Studies Section -->
    <showcase-apps
      v-if="portfolioDesktop && portfolioDesktop.length > 0"
      :title="$t('portfolio.showcaseDesktopTitle') || 'Featured Desktop Apps We\'ve Built'"
      :subtitle="$t('portfolio.showcaseDesktopSubtitle') || 'Explore our desktop development portfolio'"
      badge="Portfolio"
      :apps="portfolioDesktop"
    />

    <div class="space-top-short" id="contact">
      <Contact :items="['تطبيقات سطح المكتب', 'اضافة خاصة او عامة (SA)']" :type="0" />
    </div>
    <div id="footer">
      <main-footer />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~/assets/pages";
</style>

<script>
import Header from "~/components/Header";
import { ServiceHero } from "~/components/hero";
import Counter from "~/components/Counter";
import Contact from "~/components/Forms/Contact";
import Footer from "~/components/Footer";
import MainFeature from "~/components/Feature/MainFeature";
import ProcessTimeline from "~/components/ProcessTimeline";
import ShowcaseApps from "~/components/Portfolio/ShowcaseApps";
import portfolioData from "~/data/portfolio.json";

export default {
  components: {
    "main-header": Header,
    "main-footer": Footer,
    ServiceHero,
    MainFeature,
    Counter,
    Contact,
    ProcessTimeline,
    ShowcaseApps
  },
  head() {
    const title = this.$t("seo.desktop.title");
    const desc = this.$t("seo.desktop.desc");
    return {
      title,
      meta: [
        { hid: "description", name: "description", content: desc },
        { hid: "og:title", property: "og:title", content: title },
        { hid: "og:description", property: "og:description", content: desc },
        { hid: "og:url", property: "og:url", content: `https://www.motanamy.com${this.$route.path}` },
        { hid: "twitter:title", name: "twitter:title", content: title },
        { hid: "twitter:description", name: "twitter:description", content: desc },
      ],
    };
  },
  computed: {
    years() {
      return this.$t("desktop.process");
    },
    features() {
      return this.$t("desktop.features");
    },
    service() {
      return this.$t("services")[2];
    },
    portfolioDesktop() {
      return portfolioData.filter(item => item.type === 'desktop');
    }
  },
  data: () => ({
    data: [
      {
        icon: "mdi-electron-framework",
        value: 5400
      },
      {
        icon: "mdi-dot-net",
        value: 1050
      },
      {
        icon: "mdi-language-java",
        value: 7800
      }
    ]
  })
};
</script>
